// auth.js
import firebase from "firebase/app";

import db from "@/db";
import router from "@/router";

export default {
  namespaced: true,
  state: {
    initialized: false,
    signedIn: false,
    user: {},
  },
  mutations: {
    setSignInStatus(state, isSignedIn) {
      state.signedIn = isSignedIn;
    },
    setCurrentUser(state, user) {
      state.user = user;
    },
    setInitialized(state, isInitialized) {
      state.initialized = isInitialized;
    },
  },
  actions: {
    async init({ commit, state }) {
      if (state.initialized) {
        return true;
      }
      // TODO - ERROR CHECKING
      await new Promise((resolve) => {
        firebase.auth().onAuthStateChanged((user) => {
          if (user) {
            db.setUserId(user.uid);
            commit("setSignInStatus", true);
            commit("setCurrentUser", user);
          }
          commit("setInitialized", true);
          resolve();
        });
      });
      return true;
    },
    async signIn() {
      const provider = new firebase.auth.GoogleAuthProvider();
      firebase.auth().signInWithRedirect(provider);
    },
    async signOut({ commit }) {
      firebase.auth().signOut();
      db.setUserId(null);
      commit("setSignInStatus", false);
      commit("setCurrentUser", {});
      // TODO - Add small delay here?
      router.push({ name: "login" });
    },
  },
};
